import React, { useState, useEffect } from "react";
import classes from "../../module.css/NewBooking.module.css";
import Heading from "../../tailwindUI/Heading";
import Input from "../../tailwindUI/Input";
import Button from "../../tailwindUI/Button";
import ErrorMessage from "../../tailwindUI/ErrorMessage";
import SuccessMessage from "../../tailwindUI/SuccessMessage";
import { useNavigate } from "react-router-dom";
import WingsModal from "../../tailwindUI/WingsModal";
import Navbar from "../../tailwindUI/Navbar";

const todayDate = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    let mm = today.getMonth() + 1; // Months start at 0!
    let dd = today.getDate();

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const formattedToday = yyyy + "-" + mm + "-" + dd;
    return formattedToday;
};
const StmInterdealerBooking = () => {
    const [wingsData, setWingsData] = useState({});
    const [asmList, setAsmList] = useState([]);
    const [fName, setFname] = useState("");
    const [lName, setLname] = useState("");
    const [mobile, setMobile] = useState("");
    const [bookingDate, setBookingDate] = useState("");
    const [receiptNo, setReceiptNo] = useState("");
    const [selectedModel1, setSelectedModel1] = useState("");
    const [selectedVariant1, setSelectedVariant1] = useState("");
    const [selectedColor1, setSelectedColor1] = useState("");
    const [selectedAsm, setSelectedAsm] = useState("");
    const [selectExecutive, setSelectExecutive] = useState("");
    const [wings, setWings] = useState("");
    const [wingsLoading, setWingsLoading] = useState(false);
    const [bookingAmount, setBookingAmount] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [committedDate, setCommittedDate] = useState("");
    const [uploadReceipt, setUploadReceipt] = useState("");
    const [yom, setYom] = useState("");
    const [filteredList1, setFilteredList1] = useState([]);
    const [filteredList2, setFilteredList2] = useState([]);
    const [selectedModel2, setSelectedModel2] = useState("");
    const [selectedVariant2, setSelectedVariant2] = useState("");
    const [selectedColor2, setSelectedColor2] = useState("");
    const [executiveList, setExecutiveList] = useState([]);
    const [exchange, setExchange] = useState("No");
    const [remark, setRemark] = useState("");
    const [followup1, setFollowup1] = useState("");
    const [followup2, setFollowup2] = useState("");
    const [followup3, setFollowup3] = useState("");
    const [checkedPriority, setCheckedPriority] = useState([]);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [wingserrorMessage, setWingsErrorMessage] = useState("");
    const [showModal, setShowModal] = useState(true);

    const UserToken = localStorage.getItem("UserToken");
   
    const navigate = useNavigate();


    const notificationMethods = [
        { id: "Yes", title: "Yes" },
        { id: "No", title: "No" },
    ];

    const onlyNumeric = (e, setState) => {
        var reg = /^-?\d+$/;
        reg.test(e.target.value) || e.target.value === ""
            ? setState(e.target.value)
            : console.log("");
    };

    const validYear = (date) => {
        return date.split("-")[0];
    };

    const validation = () => {
        const commitedDate = new Date(committedDate);
        const bookingdate = new Date(bookingDate);
        const regPhone = /^[6789][0-9]{9}$/;
        let isValid = true;
        let error = {};
    
        if (!fName.trim()) {
            isValid = false;
            error.fName = "Please enter first name";
        }
        if (!lName.trim()) {
            isValid = false;
            error.lName = "Please enter last name";
        }
        if (!mobile.trim()) {
            isValid = false;
            error.mobile = "Please enter mobile number";
        } else if (!regPhone.test(mobile)) {
            isValid = false;
            error.mobile = "Invalid mobile number";
        }
        if (!bookingDate) {
            isValid = false;
            error.bookingDate = "Please select booking date";
        } else if (
            parseInt(validYear(bookingDate)) < 2016 ||
            parseInt(validYear(bookingDate)) > 2099
        ) {
            isValid = false;
            error.bookingDate = "Enter valid date";
        }
        if (!committedDate) {
            isValid = false;
            error.committedDate = "Please select committed date";
        } else if (
            parseInt(validYear(committedDate)) < 2016 ||
            parseInt(validYear(committedDate)) > 2099
        ) {
            isValid = false;
            error.committedDate = "Enter valid date";
        } else if (commitedDate < bookingdate) {
            isValid = false;
            error.committedDate = "Please enter valid date";
        }
        if (!exchange) {
            isValid = false;
            error.exchange = "Please select exchange";
        }
    
        console.log("Validation Errors:", error); // Debug log
        setErrors(error);
        return isValid;
    };
    const LogOut = () => {
        localStorage.removeItem("UserName");
        localStorage.removeItem("FirstName");
        localStorage.removeItem("LastName");
        localStorage.removeItem("UserToken");
        localStorage.removeItem("UserRole");
        localStorage.removeItem("Location");
        localStorage.removeItem("Email");
        localStorage.removeItem("UserLoggedin");
        navigate("/login", { replace: true });
    };
    const FilterList = (model, setFilteredList) => {
        var myHeaders = new Headers();
        myHeaders.append("Authorization", global.authToken);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            Model: model,
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${global.apiBaseUrl}/api/v1/stockone/common/GetFilterList`,
            requestOptions
        )
            .then((response) => response.json())
            .then((result) => {
                if (result.status === "Success" && result.status_code === 200) {
                    setFilteredList(result.data);
                } else if (result.status_code === 400) {
                    setErrorMessage("Something went wrong please contact support !");
                }
            })
            .catch((error) => {
                console.log("error", error);
                setErrorMessage("Something went wrong please contact support !");
            });
    };


    const formSubmitHandler = () => {

        if (validation()) {
            setLoading(true);
            var myHeaders = new Headers();
            myHeaders.append("Authorization", global.authToken);   
            console.log(wingsData,"545454545454545454545454545454545454545454") 
            
            var formdata = new FormData();
            formdata.append("UserToken", UserToken);
            formdata.append("customer_name", fName);
            formdata.append("LastName ", lName);
            formdata.append("customer_mobile ", mobile);
            formdata.append("car_model  ", wingsData.model_name);
            formdata.append("car_variant ", wingsData.variant);
            formdata.append("car_colour ", wingsData.colour);
            formdata.append("BookingAmount", 0);
            formdata.append("yom ", wingsData.yom);
            formdata.append("DateOfBooking", bookingDate);
            formdata.append("CommittedDeliveryDate", committedDate);
            formdata.append("receipt_num ", "N/A");
            formdata.append("win_num  ", wingsData.win_num);
            formdata.append("Exchange", exchange);
            formdata.append("ASM", "");
            formdata.append("Executive", "");
            formdata.append("Remark ", remark);
            formdata.append("followup1 ", "");
            formdata.append("followup2 ", "");
            formdata.append("followup3 ", "");
            formdata.append("GetPassNumber  ", "N/A");
            formdata.append("WingsId   ", "");
            formdata.append("executive_id", "b6229344-f5d0-11ef-8b46-0211585a676a");
            formdata.append("salesman_id", "cbca0014-4730-4521-8c6b-25b396b23a0c");
            formdata.append("car_id    ", wingsData.CarStockID);
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: formdata,
                redirect: "follow",
            };



            fetch(
                `${global.apiBaseUrl}/api/v1/stockone/am/CarStockMarkDelivered`,
                requestOptions
            )
                .then((response) => response.json())
                .then((result) => {
                    if (result.status_code === 200 && result.status === "Success") {
                        setMessage("Booking Added Successfully");
                        setWingsLoading(false)
                        setFname("");
                        setLname("");
                        setMobile("");
                        setWings("");
                        setBookingDate("");
                        setCommittedDate("");
                        setCheckedPriority([]);
                        setSelectedModel1("");
                        setSelectedVariant1("");
                        setSelectedColor1("");
                        setSelectedModel2("");
                        setSelectedVariant2("");
                        setSelectedColor2("");
                        setBookingAmount("");
                        setYom("");
                        // setSelectedStatus("");
                        setUploadReceipt(null);
                        setReceiptNo("");
                        setExchange("");
                        setSelectedAsm("");
                        setSelectExecutive("");
                        // setStatusDate("");
                        // setVinNumber("");
                        setRemark("");
                        setFollowup1("");
                        setFollowup2("");
                        setFollowup3("");
                    } else if (result.status_code === 400) {
                        setErrorMessage("Something went wrong please contact support !");
                    }
                })
                .catch((error) => {
                    console.log("error", error);
                    setErrorMessage("Something went wrong please contact support !");
                })
                .finally(() => setLoading(false));
        }
    };

    const successMessage = () => {
        setTimeout(() => {
            setMessage("");
            navigate("/stm-dashboard");
        }, 2000);
        return message;
    };
    const BreadCrumb = {
        pagename: "InterDealer",
        pagePath: "/stm-dashboard",
    };

    const fetchWingsData = (wingsId) => {
        setWingsErrorMessage("");
        setWingsLoading(true);
        var myHeaders = new Headers();
        myHeaders.append("Authorization", global.authToken);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            UserToken: UserToken,
            SearchTerm: wingsId,
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${global.apiBaseUrl}/api/v1/stockone/am/SearchFreeCarStockByVin`,
            requestOptions
        )
            .then((response) => response.json())
            .then((result) => {
                if (
                    result.message ===
                    "Invalid User Token, The token may have expired, You may need to re-login" ||
                    result.message === "Please login with a different account"
                ) {
                    LogOut();
                } else if (result.status === "Success" && result.status_code === 200) {
                    if (result.message === "data found successfully") {
                        setWingsLoading(false);
                        setShowModal(false);
                        console.log(result,"jjjjjjjjjjjjjjjjjjjjjj")
                        setWingsData(result.data);
                    } else if (result.message === "Booking Already Exists") {
                        setWingsErrorMessage("Booking Already Exists!!");
                    } else if (result.message === "data not  found") {
                        setWingsErrorMessage("Data Not Found");
                    }
                    else if (result.message === "Data not found") {
                        setWingsErrorMessage("Win No. does not exist.")
                    }
                }
            })
            .catch((error) => {
                console.log("error", error);
                setWingsErrorMessage("Something went wrong please contact support !");
            })
            .finally(() => setWingsLoading(false));
    };


    // console.log(wingsData,"54666666666666666666666666666")
    return (
        <>
            <Navbar navbarType={"black navbar"} />
            {showModal && (
                <WingsModal
                    type="STM"
                    fetchWingsData={fetchWingsData}
                    wingsLoading={wingsLoading}
                    wingserrorMessage={wingserrorMessage}
                />
            )}
            {message && <SuccessMessage message={successMessage()} />}
            {errorMessage && <ErrorMessage message={errorMessage} />}
            <Heading
                headingType={"Page Headings small"}
                BreadCrumHomeLink={"/stm-dashboard"}
                headingText={"InterDealer"}
                BreadCrumb={BreadCrumb}
                subheadingText={localStorage.getItem("Location")}
            />

            <div className={classes.mainContainer}>
                <div className={classes.searchContainer}>
                    <div className={classes.headingFormContainer}>
                        <Heading
                            headingType={"sub heading small"}
                            headingText={"Customer Details"}
                        />

                        <div className={classes.inputRow}>
                            <div className={wingsData.FirstName && classes.inputDisable}>
                                <Input
                                    disabled={wingsData.FirstName}
                                    type={"input with label low height"}
                                    inputType={"text"}
                                    label={"First Name *"}
                                    onChange={(e) => {
                                        setFname(e.target.value);
                                        errors.fName = "";
                                    }}
                                    value={fName}
                                    error={errors.fName}
                                />
                                <span className={classes.error}>{errors.fName}</span>
                            </div>
                            <div className={wingsData.LastName && classes.inputDisable}>
                                <Input
                                    type={"input with label low height"}
                                    disabled={wingsData?.LastName}
                                    inputType={"text"}
                                    label={"Last Name *"}
                                    onChange={(e) => {
                                        setLname(e.target.value);
                                        errors.lName = "";
                                    }}
                                    value={lName}
                                    error={errors.lName}
                                />
                                <span className={classes.error}>{errors.lName}</span>
                            </div>
                            <div className={wingsData.CustomerMobile && classes.inputDisable}>
                                <Input
                                    type={"input with label low height"}
                                    disabled={wingsData?.CustomerMobile}
                                    inputType={"text"}
                                    maxLength={10}
                                    label={"Mobile Number *"}
                                    onChange={(e) => {
                                        onlyNumeric(e, setMobile);
                                        errors.mobile = "";
                                    }}
                                    value={mobile}
                                    error={errors.mobile}
                                />
                                <span className={classes.error}>{errors.mobile}</span>
                            </div>
                            <div className={wingsData.BookingDate && classes.inputDisable}>
                                <Input
                                    type={"input with label low height"}
                                    disabled={wingsData?.BookingDate}
                                    inputType={"date"}
                                    label={"Date of Booking *"}
                                    onChange={(e) => {
                                        setBookingDate(e.target.value);
                                        errors.bookingDate = "";
                                    }}
                                    value={bookingDate}
                                    error={errors.bookingDate}
                                    onKeyDown={(e) => e.preventDefault()}
                                />
                                <span className={classes.error}>{errors.bookingDate}</span>
                            </div>
                            <div>
                                <Input
                                    type={"input with label low height"}
                                    inputType={"date"}
                                    label={"Commited Delivery Date*"}
                                    onChange={(e) => {
                                        setCommittedDate(e.target.value);
                                        errors.committedDate = "";
                                    }}
                                    value={committedDate}
                                    error={errors.committedDate}
                                    onKeyDown={(e) => e.preventDefault()}
                                />
                                <span className={classes.error}>{errors.committedDate}</span>
                            </div>

                        </div>
                    </div>

                    <div>
                        <Heading
                            headingType={"sub heading small"}
                            headingText={"Other Details"}
                        />
                        <div className={classes.inputRow}>
                            <div className={classes.radiobuttonWrapper}>
                                <div>
                                    <Input
                                        type={"radio group"}
                                        label="Exchange *"
                                        value={exchange}
                                        setState={setExchange}
                                        data={notificationMethods}
                                        onChange={() => (errors.exchange = "")}
                                    />

                                    <span className={classes.error}>{errors.exchange}</span>
                                </div>
                            </div>

                            {/* <div className={`${classes.inputWrapper} col-span-4`}>
                                <div>
                                    <Input
                                        type={"textarea"}
                                        inputType={"text"}
                                        rows={1}
                                        label={"Remark "}
                                        onChange={(e) => {
                                            setRemark(e.target.value);
                                        }}
                                        value={remark}
                                    />
                                </div>
                            </div> */}
                        </div>
                        <div className={classes.submitButtonWrapper}>
                            <Button
                                type={"whiteButton"}
                                buttonText={"Cancel"}
                                onClick={() => navigate("/stm-dashboard")}
                            />
                            <div className={classes.submitButton}>
                                <Button
                                    type={"smallButton"}
                                    buttonText={"Save"}
                                    onClick={() => {
                                        formSubmitHandler();
                                    }}
                                    loading={loading}
                                    disabled={loading}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default StmInterdealerBooking;
